<template>
<ItpBadge
  :title="_.get(tariffs, `${value}.name`, null)"
  no-box-shadow
  variant="light"
  class="badge-icon border"
  v-if="value"
>
  <ItpIcon
    :name="$config.tariff.icon"
  >
  </ItpIcon>
  <ItpText
    :text="value"
    class="ml-2"
  >
  </ItpText>
</ItpBadge>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcTariffCodeBadge extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  value!: string;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  tariffs!: any;

  async $$load_tariffs() {
    return this.$app.repo
      .get('list_object_by_type', { parameters: { object_type: 'tariff' } })
      .then(
        items => _.reduce(items, (m, v) => _.set(m, v.code, v), {})
      )
  }

  ux!: any;
  dataMembers = ['tariffs', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        tariffs: null,
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcTariffCodeBadge", UcTariffCodeBadge);

</script>